/**
 * Store: Header
 * -----------------------------------------------------------------------------
 * Root store for any header customisations.
 * - Tied to the site-header component.
 * - Only JSDOC custom parameters, ignore module state or object.
 *
 */
 export default {
  namespaced: true,

  state: () => ({
    secondaryLinks: [],
    transparency: false,
    secondaryHeaderMobileOnly: false,
    secondaryHeaderVisible: false,
  }),

  mutations: {

    /**
     * Set secondary menu links.
     * @param {Array} links - Array of links.
     */
    SET_SECONDARY_LINKS(state, links) {
      state.secondaryLinks = links
    },

    /**
     * Set transparency.
     * @param {Boolean} enabled - Whether the header should be transparent.
     */
    SET_TRANSPARENCY(state, enabled) {
      state.transparency = enabled
    },

    /**
     * Set transparency.
     * @param {Boolean} enabled - Whether the header should be transparent.
     */
    SET_SECONDARY_MOBILE_ONLY(state, enabled) {
      state.secondaryHeaderMobileOnly = enabled
    },

    /**
     * Set transparency.
     * @param {Boolean} enabled - Whether the header should be transparent.
     */
     SET_SECONDARY_HEADER_VISIBLE(state, visible) {
      state.secondaryHeaderVisible = visible
    },
  },

  actions: {

    /**
     * Commit secondary header menu.
     * @param {Array} links - Array of links to display in the secondary header.
     */
    setSecondaryLinks({ commit }, links) {
      commit('SET_SECONDARY_LINKS', links)
    },

    /**
     * Commit transparent header state.
     * @param {Boolean} enabled - Whether the header should be transparent.
     */
    setTransparency({ commit }, enabled) {
      commit('SET_TRANSPARENCY', enabled)
    },

    /**
     * Commit transparent header state.
     * @param {Boolean} enabled - Whether the header should be transparent.
     */
    setSecondaryMobileOnly({ commit }, enabled) {
      commit('SET_SECONDARY_MOBILE_ONLY', enabled)
    },

     /**
     * Commit transparent header state.
     * @param {Boolean} enabled - Whether the header should be transparent.
     */
      setSecondaryHeaderVisible({ commit }, visible) {
        commit('SET_SECONDARY_HEADER_VISIBLE', visible)
      },
  },
}
